import { createEvent, restore, sample } from 'effector'
import { LandingItem } from '../types'
import { fx, path } from 'src/libs'
import { $params, toPath } from '../../../../../features/router'
import { RequestError } from '../../../../../shared/errorResponse'

export const landingMounted = createEvent()

export const setLandingForm = createEvent<LandingItem>()

export const setError = createEvent<RequestError>()

export const submitUpdateLanding = createEvent<LandingItem>()

export const $landing = restore(setLandingForm, {
  lang: '',
  title: '',
  link: '',
  isVisible: false,
})

export const getLanding = fx<void, LandingItem>({
  method: 'GET',
  url: '/partner/material/landing_page/{landingID}',
})

export const updateLanding = fx<LandingItem, void>({
  method: 'PUT',
  url: '/partner/material/landing_page/{landingID}',
})

export const $error = restore(setError, {
  message: '',
  code: 0,
})

sample({
  clock: landingMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.landingID
    }
    return {
      url: `/partner/material/landing_page/${id}`,
    }
  },
  target: getLanding,
})

sample({
  clock: submitUpdateLanding,
  source: $params,
  fn: (params, landing) => {
    let id
    if (params) {
      id = params.landingID
    }

    return {
      url: `/partner/material/landing_page/${id}`,
      body: { ...landing },
    }
  },
  target: updateLanding,
})

sample({
  clock: [getLanding.doneData],
  fn: (doneData) => doneData.body,
  target: [setLandingForm],
})

sample({
  clock: [updateLanding.doneData],
  target: toPath.prepend(path.ib.ad.landing.entry),
})

sample({
  clock: updateLanding.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})
